import React from 'react';
import Header from './Header';
import ProductGridPure from './ProductGridPure';
import Footer from './Footer';
import './BoutiquePage.css';

const BoutiquePagePure = () => {
  return (
    <div className="boutique-page">
      <Header />
      <main className="boutique-main">
        <div className="container">
          <div className="boutique-header">
            <h1>Boutique</h1>
            <p>Découvrez notre sélection de produits premium</p>
          </div>
          <ProductGridPure />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BoutiquePagePure;
